module.exports = __webpack_public_path__ + "static/media/sonar.da70ad76.avif";